<template>
    <el-drawer
        title="编辑"
        :visible.sync="drawer"
        :modal="true"
        :wrapperClosable="false"
        size="600px"
        @close="closeDrawer"
        :modal-append-to-body="false"
        :direction="direction">

        <!-- title -->
        <div class="drawer_form">
            
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
                
                <div class="form-body">
                    <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                        <el-form-item label="资源名称" prop="name">
                            <el-input type="text" v-model="form.name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="资源描述" prop="">
                            <el-input type="text" v-model="form.description" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="资源类型" prop="">
                            <el-select v-model="source_type_value" @change="handleChange" class="w-full" placeholder="请选择">
                                <el-option
                                v-for="item in source_type"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="资源内容(文本)" prop="" v-if="source_type_value==1">
                            <el-input type="textarea" rows="6" v-model="form.content" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="资源内容(链接)" prop="" v-else-if="source_type_value==2">
                            <el-input type="text" v-model="form.resourceUri" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="uploadLabel" prop="" v-else-if="[3,4,5,6,7].includes(source_type_value)">
                            <div class="upload-wrapper">
                                <el-upload
                                    :action="uploadUrl"
                                    :headers="uploadHeaders"
                                    :on-success="uploadSuccess"
                                    :on-progress="handleUploadProgress"
                                    :before-upload="beforeUpload"
                                    :show-file-list="false"
                                    :disabled="uploading">
                                    <el-button size="small" type="primary" :loading="uploading">
                                        {{ uploading ? '上传中...' : '点击上传' }}
                                    </el-button>
                                </el-upload>
                                <el-progress 
                                    v-if="uploadProgress > 0 && uploadProgress < 100" 
                                    :percentage="uploadProgress" 
                                    style="margin-top: 10px;">
                                </el-progress>
                                <div v-if="form.resourceUri" class="uploaded-info">
                                    <span>已上传文件路径：</span>
                                    <el-input v-model="form.resourceUri" size="small" readonly style="margin-top: 5px;">
                                        <el-button slot="append" @click="clearUpload">清除</el-button>
                                    </el-input>
                                </div>
                            </div>
                        </el-form-item>
                    </overlay-scrollbars>
                </div>

                <div class="form-foot d-flex a-center j-center">
                    <el-button @click="onSubmit"  class="common-button" >提交</el-button>
                </div>
            </el-form>
        </div>

    </el-drawer>
    
</template>

<script>
import {update,get} from '@/request/api/source.js'
import {getFileUrl} from '@/request/api/login.js'
export default {
    data(){
        return {
            drawer: true, //表单
            direction: 'rtl',//抽屉方向
            loading:false,
            uploadUrl: '', // 上传地址
            uploadProgress: 0, // 上传进度
            uploading: false, // 上传中状态
            form:{
                id:'',
                name:'',
                resourceUri:'',
                content:'',
                description:''
            },
            source_type_value:1,
            source_type:[{label:'文本',value:1},{label:'超链接',value:2},{label:'Word',value:3},{label:'Excel',value:4},{label:'PPT',value:5},{label:'图片',value:6},{label:'视频',value:7}],
            rules:{
                name:[
                    { required: true, message: '请输入资源名称', trigger: 'blur' },
                ],
            }
        }
    },
    computed:{
        // 上传请求头
        uploadHeaders(){
            return {
                Authorization: this.$store.state.user.token
            }
        },
        // 根据资源类型显示不同的标签
        uploadLabel(){
            const labels = {
                3: '资源内容(Word)',
                4: '资源内容(Excel)',
                5: '资源内容(PPT)',
                6: '资源内容(图片)',
                7: '资源内容(视频)'
            }
            return labels[this.source_type_value] || '资源内容'
        },
        // 根据资源类型限制文件格式
        acceptTypes(){
            const types = {
                3: '.doc,.docx',
                4: '.xls,.xlsx',
                5: '.ppt,.pptx',
                6: '.jpg,.jpeg,.png,.gif,.bmp,.webp',
                7: '.mp4,.avi,.mov,.wmv,.flv,.mkv'
            }
            return types[this.source_type_value] || ''
        }
    },
    created(){
        this.form.id = this.$route.query.id || ''
        this.init()
        this.initUploadUrl()
    },
    methods:{
        // 初始化上传地址
        initUploadUrl(){
            getFileUrl().then(res => {
                // 拼接完整的上传URL
                const baseURL = window.apiUrl?.baseURL || process.env.VUE_APP_BASE_URL || ''
                this.uploadUrl = baseURL + res
            })
        },
        
        init(){
            get(this.form.id).then(res=>{
                Object.keys(this.form).forEach(item=>{
                    this.form[item] = res.data[item]
                })
                // 根据后端返回的type字段判断资源类型，如果没有则根据content和resourceUri判断
                if(res.data.type) {
                    this.source_type_value = res.data.type
                } else {
                    // 兼容旧数据：1=文本(有content)，其他=链接(有resourceUri)
                    this.source_type_value = res.data.content ? 1 : 2
                }
            })
        },
        
        // 上传前校验
        beforeUpload(file){
            const acceptTypes = this.acceptTypes.split(',')
            const fileExt = '.' + file.name.split('.').pop().toLowerCase()
            const isValidType = acceptTypes.some(type => type.toLowerCase() === fileExt)
            
            if (!isValidType) {
                this.$message.error(`请上传 ${this.acceptTypes} 格式的文件`)
                return false
            }
            
            this.uploadProgress = 0
            this.uploading = true
            return true
        },
        
        // 上传进度
        handleUploadProgress(event){
            if(event.percent){
                this.uploadProgress = Math.floor(event.percent)
            }
        },
        
        // 上传成功
        uploadSuccess(res){
            this.uploading = false
            this.uploadProgress = 100
            if(res.code !== 0) {
                this.$message.error(res.msg || '上传失败')
                return
            }
            this.form.resourceUri = res.data?.url || res.data?.path || ''
            this.$message.success('上传成功')
        },
        
        // 清除已上传文件
        clearUpload(){
            this.form.resourceUri = ''
            this.uploadProgress = 0
        },
        
        onSubmit(){
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false;
                }
            });
        },
        
        //req
        req(){
            update(this.form).then(res=>{
                if(res.code!=0) return this.$notify({title: '失败',message:res.msg,type: 'error'});
                this.$notify({title: '成功',message: "SUCCESS",type: 'success'});
                this.$router.go(-1)
            }) 
        },

        handleChange(val){
            this.form.resourceUri = ''
            this.form.content = ''
            this.uploadProgress = 0
        },


        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //关闭抽屉
        closeDrawer(){
            this.$router.go(-1)
        }
    }

}
</script>


<style lang="less" scoped>
.drawer_form {
    width: 96%;
    margin: auto;
    .drawer_form_title {
        color: #17233d;
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        line-height: 48px;
        margin-bottom: 20px;
    }

    .drawer_line {
        margin-bottom: 30px;
        .drawer_line_text {
            width: 120px;
            margin-right: 20px;
            text-align: right;
            color: #515a6e;
        }    
    }

}
.form-items {
    background-color:#f5f6fb;padding:15px 10px;height:500px;
}

/deep/ .form-items .el-form-item ,/deep/ .form-items .el-form-item .el-form-item__content{
    width: 100%;
}

.upload-wrapper {
    width: 100%;
    .uploaded-info {
        margin-top: 10px;
        padding: 10px;
        background-color: #f5f7fa;
        border-radius: 4px;
        span {
            color: #606266;
            font-size: 13px;
        }
    }
}

</style>
